import { Fragment, FunctionComponent } from "react";
import { Rule } from "../api";
import { numberUtils } from "../number-utils";

export const PolicyRules: FunctionComponent<{ rules?: Rule[] }> = ({
  rules,
}) => {
  return (
    <>
      {rules?.map((x, index) => (
        <Fragment key={index}>
          <div>
            <span className="description">Activity:</span>
            <span>{x.Activity}</span>
          </div>
          {x.MaxStay != null && (
            <div>
              <span className="description">Max Stay:</span>
              <span>
                {x.MaxStay}&nbsp;{x.MaxStayUnit}
              </span>
            </div>
          )}
          {!!x.UserClasses?.length && (
            <div>
              <span className="description">Use:</span>
              <span>{x.UserClasses.join(", ")}</span>
            </div>
          )}
          {x.NoReturn != null && (
            <div>
              <span className="description">Return Interval:</span>
              <span>
                {x.NoReturn}&nbsp;{x.NoReturnUnit}
              </span>
            </div>
          )}
          {!!x.Rate?.length && (
            <div>
              <span className="description">Rate:</span>
              {x.Rate.map((y, index2) => (
                <span key={index2}>
                  {!y.StartDuration
                    ? `$${numberUtils.toUiString(
                        y.Rate * 0.01,
                        undefined,
                        undefined,
                        "en-US"
                      )}/${y.RateUnit}`
                    : `$${numberUtils.toUiString(
                        y.Rate * 0.01,
                        undefined,
                        undefined,
                        "en-US"
                      )} from ${y.StartDuration} ${y.RateUnit}`}
                  {index2 < (x.Rate?.length ?? 0) - 1 && <span>, </span>}
                </span>
              ))}
            </div>
          )}
        </Fragment>
      ))}
    </>
  );
};
